import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import _ from 'underscore';

import Image from './Image';
import Loading from './CircularLoading';
import TextMessage from './TextMessage';

import { fetchLocationData } from '../actions/location';
import { SEND_STATUS } from '../constants/message';
import { COLORS } from '../constants/styles';
import { getLocationKey } from '../utils/message';

class LocationMessageComponent extends Component {
    static propTypes = {
        accentColor: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        coordinates: PropTypes.object,
        dispatch: PropTypes.func.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        locationData: PropTypes.object.isRequired,
        locationSendingFailedText: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
        sendStatus: PropTypes.string.isRequired,
        text: PropTypes.string,
        type: PropTypes.string.isRequired,
        authorId: PropTypes.string.isRequired,
        currentUser: PropTypes.object.isRequired,
    };

    state = {};

    componentDidMount() {
        this.fetchLocation(this.props);
    }

    componentDidUpdate(prevProps) {
        const { coordinates, isAuthenticated } = this.props;

        if (!_.isEqual(coordinates, prevProps.coordinates) || (isAuthenticated && !prevProps.isAuthenticated)) {
            this.fetchLocation(this.props);
        }
    }

    fetchLocation(props) {
        const { dispatch, locationData, coordinates, isAuthenticated } = props;
        const storedLocation = coordinates && locationData[getLocationKey(coordinates)];

        if (coordinates && isAuthenticated && !storedLocation) {
            dispatch(fetchLocationData(props)).then(() => this.verifyLocationError());
        } else {
            this.verifyLocationError();
        }
    }

    onError = () => {
        this.setState({
            hasLocationError: true,
        });
    };

    verifyLocationError() {
        const { coordinates, locationData } = this.props;
        const { hasError } = (coordinates && locationData[getLocationKey(coordinates)]) || {};

        if (!this.state.hasLocationError && hasError) {
            this.setState({
                hasLocationError: true,
            });
        }
    }

    render() {
        const {
            accentColor,
            className,
            coordinates,
            locationData,
            locationSendingFailedText,
            sendStatus,
            role,
            text,
            type,
            authorId,
            currentUser,
        } = this.props;
        const parsedData = (coordinates && locationData[getLocationKey(coordinates)]) || {};
        const { mapUrl, mapImageUrl } = parsedData;

        const shouldDisplayImage = !this.state.hasLocationError && (mapUrl || mapImageUrl);

        switch (sendStatus) {
            case SEND_STATUS.FAILED:
                return (
                    <TextMessage
                        className={className}
                        text={locationSendingFailedText}
                        role={role}
                        authorId={authorId}
                        currentUser={currentUser}
                    />
                );
            case SEND_STATUS.SENT:
                return shouldDisplayImage ? (
                    <Image
                        accentColor={accentColor}
                        forceShowLoader={!mapImageUrl}
                        imageUrl={mapImageUrl}
                        loaderClassName="loader-container"
                        onClickUrl={mapUrl}
                        onError={this.onError}
                        preloaderImageUrl={mapImageUrl}
                        type={type}
                    />
                ) : (
                    <TextMessage
                        className={className}
                        role={role}
                        text={text}
                        type={type}
                        authorId={authorId}
                        currentUser={currentUser}
                    />
                );
            default:
                return (
                    <div className={className}>
                        <Loading color={role === 'appMaker' ? `#${accentColor}` : COLORS.WHITE} />
                    </div>
                );
        }
    }
}

export default connect(
    ({ auth: { jwt, sessionToken }, location, ui: { text } }) => {
        return {
            isAuthenticated: !!jwt || !!sessionToken,
            locationData: location.data,
            locationSendingFailedText: text.locationSendingFailed,
        };
    },
    undefined,
    undefined,
    {
        forwardRef: true,
    },
)(LocationMessageComponent);
